import React from "react";
import {
  GroupingAttributes,
  VariationMembership,
} from "~/common/Store/models/ProductListing";
import combineVariationsAndVirtualGroupingOptions from "./useVariationsAndVirtualGroupingOptionsForOptionLabel";
import Badge from "./Badge";
import VariationOptionLabel from "./VariationOptionLabel";
import { blockedVariations, blockedBadges } from "./constants";
interface BadgeAndOptionTextProps {
  showBadge: boolean;
  hasVariations: boolean;
  badgeDisplayText: string;
  badgeImagePath: string;
  groupingAttributes: GroupingAttributes;
  variations?: VariationMembership;
  isListView?: boolean;
}

const BadgeAndOptionText = ({
  showBadge,
  hasVariations,
  badgeDisplayText,
  badgeImagePath,
  groupingAttributes,
  variations,
  isListView = false,
}: BadgeAndOptionTextProps) => {
  const isBlockedBadge = blockedBadges.includes(badgeDisplayText);
  const isBlockedVariation =
    variations?.variationGroups.some((group) =>
      blockedVariations.includes(group.optionName),
    ) || false;

  const isNotBlocked =
    hasVariations && (!isBlockedVariation || !isBlockedBadge);

  const itemDisplaysBadge = showBadge && (isNotBlocked || !hasVariations);

  const optionsData = combineVariationsAndVirtualGroupingOptions({
    groupingAttributes,
    variationMembership: variations,
    itemDisplaysBadge,
    isListView,
  });

  if (!optionsData) {
    return (
      <span className="inline-flex items-center justify-center">
        {showBadge && (
          <Badge text={badgeDisplayText} badgeImage={badgeImagePath} />
        )}
      </span>
    );
  }

  const {
    uniqueCounts,
    numberOfUniqueOptions,
    wrapperClass,
    overrideMap,
    shouldDisplayOptionText,
    optionTextWrapperClass,
  } = optionsData;

  return (
    <span className="inline-flex items-center justify-center badgeSpan">
      {itemDisplaysBadge && (
        <Badge text={badgeDisplayText} badgeImage={badgeImagePath} />
      )}
      {(groupingAttributes.isVirtual || hasVariations) && (
        <VariationOptionLabel
          uniqueCounts={uniqueCounts}
          numberOfUniqueOptions={numberOfUniqueOptions}
          wrapperClass={wrapperClass}
          overrideMap={overrideMap}
          shouldDisplayOptionText={shouldDisplayOptionText}
          optionTextWrapperClass={optionTextWrapperClass}
        />
      )}
    </span>
  );
};

export default React.memo(BadgeAndOptionText);
